import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { CostCentersStructureDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CostCentersNestedList } from 'modules/cost_centers/components/CostCenterNestedList'
import { EmptyCostCentersStructure } from 'modules/cost_centers/components/CostCentersStructure/EmptyState'
import { hasCostCenterConfigurationPending } from 'modules/cost_centers/lib/costCenterHelpers'
import { CostCenterConfigurations } from 'modules/cost_centers/lib/types'

import { CostCenterConfiguration } from './Configuration'

const CostCentersStructure = ({
  configurations,
  canManageCostCenters,
}: {
  canManageCostCenters: boolean
  configurations: CostCenterConfigurations
}) => {
  const [configure, setConfigure] = useState<boolean>(false)

  const { data: structureData, loading: structureLoading } = useQuery(CostCentersStructureDocument)

  const hasConfigurationPending = useUnsafeMemo(() => {
    return hasCostCenterConfigurationPending(configurations)
  }, [configurations])

  if (structureLoading) {
    return (
      <Box flexGrow justifyContent="center" alignItems="center">
        <Loading />
      </Box>
    )
  }

  if (configurations.length === 0 || hasConfigurationPending) {
    return (
      <>
        <EmptyCostCentersStructure
          canManageCostCenters={canManageCostCenters}
          startConfiguration={() => setConfigure(true)}
          hasConfigurationPending={hasConfigurationPending}
          hasWorkplaces={!!structureData?.locations?.locations?.length}
          hasJobCatalog={!!structureData?.jobCatalog?.treesConnection?.nodes?.length}
        />
        {configure && (
          <CostCenterConfiguration data={structureData} cancel={() => setConfigure(false)} />
        )}
      </>
    )
  }

  return (
    <CostCentersNestedList
      canManageCostCenters={canManageCostCenters}
      configurations={configurations}
    />
  )
}

export { CostCentersStructure }
